import { Box, Text } from '@wix/design-system';
import React from 'react';
import { useIsMobile } from '../../../hooks';
import s from './SidedIconTrustBuilder.scss';
export const SidedIconTrustBuilder = ({ icon, title, description, }) => {
    const isMobile = useIsMobile();
    if (isMobile) {
        return (React.createElement(Box, { direction: "vertical", minWidth: "188px", gap: "SP1", align: "center" },
            React.createElement(Box, { direction: "horizontal", align: "center", verticalAlign: "middle" },
                React.createElement(Box, { marginRight: "SP2", height: "20px", width: "17px", verticalAlign: "middle" }, icon),
                React.createElement(Text, { weight: "bold", size: "tiny", className: s.title }, title)),
            React.createElement(Text, { weight: "thin", size: "tiny", className: s.alignCenter }, description)));
    }
    return (React.createElement(Box, { direction: isMobile ? 'vertical' : 'horizontal', align: "center", verticalAlign: "middle" },
        React.createElement(Box, { height: "40px", width: "40px" }, icon),
        React.createElement(Box, { direction: "vertical", padding: "SP3", gap: "SP1" },
            React.createElement(Text, { weight: "bold", size: "tiny", className: s.title }, title),
            React.createElement(Text, { weight: "thin", size: "tiny" }, description))));
};
//# sourceMappingURL=SidedIconTrustBuilder.js.map